import { graphql } from '@teachino/shared-infrastructure';

export const itemSyncDetailsQuery = graphql(`
  query ItemSyncDetails($itemId: String!) {
    material(materialIdInput: { id: $itemId }) {
      __typename
      id
      name
      originDetails {
        id
        newAdditions
        contentChanged
      }
      permissions {
        canEditItem
      }
    }
  }
`);
